import WorkOrderDetailContainer from '@components/containers/workOrders/WorkOrderDetailContainer';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const WorkOrderDetail: FC = () => (
    <AppLayout>
        <WorkOrderDetailContainer />
    </AppLayout>
);

export default WorkOrderDetail;
